import React from 'react';

const Cutlery = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31.6 30"
    style={{
      enableBackground: 'new 0 0 31.6 30'
    }}
    height={20}
    width={20}
    xmlSpace="preserve"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <path
      d="M27.1.5v28.9M27.4.5c1.8 0 3.7 8.8 3.7 19.5h-4M.5 1.8v6.7c0 2.2 1.8 4 4 4s4-1.8 4-4V1.8m-4 10.8v16.8M3.1 1.8V9m2.7-7.2V9"
      style={{
        fill: 'none',
        stroke: '#224251',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
    />
    <path
      d="M24.5 20.7c0 4.8-3.9 8.8-8.7 8.8s-8.7-3.9-8.7-8.8c0-4.8 3.9-8.8 8.7-8.8s8.7 4 8.7 8.8z"
      style={{
        fill: 'none',
        stroke: '#224251',
        strokeLinejoin: 'round'
      }}
    />
  </svg>
);

export default Cutlery;
